import "swiper/css";

import ChallengeCard from "./ChallengeCard";
import { DataContext } from "../contexts/runesContext";
import React from "react";
import SliderSection from "./SliderSection";
import { SwiperSlide } from "swiper/react";
import challengeImg1 from "../assets/challenge-1.png";
import challengeImg2 from "../assets/challenge-2.png";
import challengeImg3 from "../assets/challenge-3.png";
import { useContext } from "react";
import { useMoralis } from "react-moralis";
import { v4 } from "uuid";

// Import Swiper styles

const challengesData = [
  {
    id: v4(),
    img: challengeImg1,
    title: "#respiratalagante",
    sponsor: "Cabra de Cerro",
    funded: true,
    currentFunding: "",
    fundingGoal: "",
    reward: "1000",
    description:
      "Subir una foto en acción o un enlace con la publicación que demuestre su participación en los eventos oficiales de SuperBee. Y presionar el botón verde. ",
    requeriments: "",
    start: "1/11/20",
    end: "Indefinido",
  },
  {
    id: v4(),
    img: challengeImg2,
    title: "#desafiolimpiemoschile",
    sponsor: "Superbee.cl",
    funded: false,
    currentFunding: "25000",
    fundingGoal: "30000",
    reward: "",
    start: "1/11/20",
    end: "Indefinido",
    description:
      "Subir una foto en acción o un enlace con la publicación que demuestre su participación en los eventos oficiales de SuperBee. Y presionar el botón verde. ",
  },
  {
    id: v4(),
    img: challengeImg3,
    title: "#estadiolimpio",
    sponsor: "Club x",
    funded: false,
    currentFunding: "20000",
    fundingGoal: "23000",
    reward: "",
    start: "1/11/20",
    end: "Indefinido",
    description:
      "Subir una foto en acción o un enlace con la publicación que demuestre su participación en los eventos oficiales de SuperBee. Y presionar el botón verde. ",
  },
  {
    id: v4(),
    img: challengeImg1,
    title: "#respiratalagante",
    sponsor: "Cabra de Cerro",
    funded: true,
    currentFunding: "",
    fundingGoal: "",
    reward: "1000",
    description:
      "Por la #PROTECCION de la #NATURALEZA estoy en el #SORTEO de una deliciosa #Pizza Familiar + #PalitosDeAjo + 1 Bebida cortesía de @santogrialpizzeria Gracias a @cabra_de_cerro y su #proposito de educar, proteger y regenerar el bosque nativo de la comuna de #Talagante, y que en #simbiosis con @opiswallet conectan las #FinanzasRegenerativas a los #desafios #socioambientales.    #cabradecerro #responsabilidad #ambiental #senderismo #trekking #economiaCircular #turismoRegenerativo #Chile #turismo #nature #cabrasdecerro #ecologia #sustentable",

    requeriments: "Materiales: 100 bolsas de basura y 15 palas, Personas: 20 personas ",
    start: "1/11/20",
    end: "Indefinido",
  },
];

const Challenges = ({ challengesSection }) => {
  const { contextData, setContextData } = useContext(DataContext);

  const { Moralis, account, isInitialized, isAuthenticated } = useMoralis();

  async function addRunes() {
    if ((isInitialized, isAuthenticated)) {
      const runesTable = Moralis.Object.extend("Runes");
      const queryRunes = new Moralis.Query(runesTable);

      queryRunes.equalTo("ethAddress", account);
      const dataRunes = await queryRunes.first();

      const result = await dataRunes.increment("runes", 1000);
      dataRunes.save();
      console.log(result);
      setContextData({ runes: contextData.runes + 1000 });
    } else {
      console.log("Error: Invalid session");
    }
  }

  const buttonsData = [{ text: "ReFi" }, { text: "Deporte" }, { text: "ONG" }, { text: "Todos" }];

  return (
    <SliderSection
      title={"Desafíos"}
      subTitle={"ganar OPIS"}
      sectionLabel={true}
      buttonsLabelData={buttonsData}
      refSection={challengesSection}
      sliderSectionStyle={{ height: "fit-content", marginBottom: "48px" }}
    >
      {challengesData.map((challenge, i) => (
        <SwiperSlide key={i} style={{ width: "fit-content" }}>
          <ChallengeCard account={account} addRunes={addRunes} {...challenge} />
        </SwiperSlide>
      ))}
    </SliderSection>
  );
};

export default Challenges;
